'use client';

import { useState } from 'react';
import Cookies from 'js-cookie';
import useSWR from 'swr';
import { fetcher } from '@/shared/api/fetcher';

const CLICK_ID_PARAM = 't';
const SUB_KEYS = new Set([
  'sub1',
  'sub2',
  'sub3',
  'sub4',
  'sub5',
  'sub6',
  'sub7',
  'sub8',
]);

const buildIncClickQuery = (): string | null => {
  if (typeof window === 'undefined') return null;
  if (Cookies.get('sessionId')) return null;

  const sourceParams = new URLSearchParams(window.location.search);
  const clickId = sourceParams.get(CLICK_ID_PARAM);

  if (!clickId) return null;

  const params = new URLSearchParams();
  params.set(CLICK_ID_PARAM, clickId);

  sourceParams.forEach((value, key) => {
    if (key.startsWith('utm_') || SUB_KEYS.has(key)) {
      params.set(key, value);
    }
  });

  if (document.referrer) {
    params.set('referrer', document.referrer);
  }

  return params.toString();
};

const IncClickTracker = () => {
  const [query] = useState(buildIncClickQuery);

  useSWR(query ? `/incClick?${query}` : null, fetcher, {
    shouldRetryOnError: false,
    onError: () => {},
  });

  return null;
};

export { IncClickTracker };
